import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  inputField: {
    width: '100%',
  }
}));

export default styles;
